module.exports = __webpack_public_path__ + "static/media/voice_over.1f90e942.svg";